import React from 'react';
import 'twin.macro';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import request from '@teetsh/app/src/utils/request';
import { useTranslation } from 'react-i18next';
import ButtonLink from '@teetsh/app/src/components/Buttons/Link';
import { SCHOOLYEARS_TRASH_KEY } from '@teetsh/app/src/containers/UserSettings/Trash/Schoolyears/useSchoolyearsTrash';
import { SCHOOLYEARS_KEY } from '@teetsh/app/src/queries/schoolyears/useSchoolyears';
import { SCHOOLYEARS_WITH_SCHOOLS_AND_CLASSROOMS_KEY } from '@teetsh/app/src/queries/schoolyears/useSchoolyearsWithSchoolsAndClassrooms';

export function useRestoreSchoolyear() {
  const { notifySuccess, notifyError } = useNotification();
  const queryClient = useQueryClient();
  const { t } = useTranslation(['userSettings']);
  const { mutateAsync } = useMutation({
    mutationFn: ({ id }: { id: string }) =>
      request(`/schoolyears/${id}/restore`, { method: 'PATCH' }),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({
        queryKey: [SCHOOLYEARS_TRASH_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [SCHOOLYEARS_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [SCHOOLYEARS_WITH_SCHOOLS_AND_CLASSROOMS_KEY],
      });
      notifySuccess({
        title: t('userSettings:restore.messages.success'),
        message: (
          <ButtonLink
            outlined
            intent="success"
            to={`/mes-annees-scolaires/${id}`}
          >
            {t('userSettings:restore.messages.see')}
          </ButtonLink>
        ),
      });
    },
    onError: () => {
      notifyError({ title: t('userSettings:restore.messages.error') });
    },
  });
  return mutateAsync;
}
